/**
 * @generated SignedSource<<c3f4d859cae83d960aea68baff706d9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Cost_template$data = {
  readonly gameCost: number | null;
  readonly " $fragmentType": "Cost_template";
};
export type Cost_template$key = {
  readonly " $data"?: Cost_template$data;
  readonly " $fragmentSpreads": FragmentRefs<"Cost_template">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Cost_template",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gameCost",
      "storageKey": null
    }
  ],
  "type": "GameTemplate",
  "abstractKey": null
};

(node as any).hash = "126126b290846ff3b109975a3eed3d25";

export default node;
